import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/shop/Homepage.vue'
import store from "../store/";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/features',
    name: 'Features',
    component: () => import('../views/shop/Features.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/auth/Register.vue')
  },
  {
    path: '/activate-account',
    name: 'Activate Account',
    component: () => import('../views/auth/ActivateAccount.vue')
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import('../views/auth/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('../views/auth/ResetPassword.vue')
  },
  {
    path: '/not-found',
    name: 'Not Found',
    component: () => import('../views/NotFound.vue')
  },
  { path: '/cart', redirect: '/not-found', },
  { path: '/purchases', redirect: '/not-found', },
  { path: '/my-products', redirect: '/not-found', },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../views/user/Account.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if((to.path == "/account" || to.path == "/purchases") && store.getters["authModule/auth"].userId.length <= 0)
  {
    next( {path: "/login"} )
  }else if((to.path == "/login" || to.path == "/register") && store.getters["authModule/auth"].userId.length > 0)
  {
    next( {path: "/"} )
  }else{
    next()
  }
})

export default router
